// extracted by mini-css-extract-plugin
module.exports = {"loader":"GridLoader_loader__1-CY4"};